
















































































import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig, UseModal } from "@/components/root/modal";
import {
  computed,
  onBeforeUnmount,
  onMounted,
  Ref,
  ref,
  watch,
} from "@vue/composition-api";
import { UseTabs } from "@/common/composition/use-tabs";
import SimpleNavTabs from "@/components/SimpleNavTabs.vue";
import { UseCurrentSource } from "../../data/current-source.state";
import { state } from "../../data/state";
import Connections from "./Connections.vue";
import Sessions from "./Sessions.vue";
import Processing from "@/components/table/Processing.vue";
import { emptyFn, prop } from "@/fp";
import Spinner from "@/components/Spinner.vue";
import { SourceBrief, SourceConnection } from "../../data/model";
import { EventBus } from "@/eventbus";
import WalkthroughModalVue from "@/components/modals/walkthrough-modal/WalkthroughModal.vue";
export type SessionConnectionFilters = {
  connection: SourceConnection;
  session_is_active: boolean;
};

export default Vue.extend({
  components: {
    Modal,
    SimpleNavTabs,
    Connections,
    Sessions,
    Processing,
    Spinner,
  },
  props: ["modalData"],
  setup(props, { emit }) {
    const config: ModalConfig = {
      title: "",
      desc: "",
      blank: true,
      width: "85rem",
      height: "60rem",
      withTopRightCloseBtn: true,
    };

    const {
      add_connection,
      add_session,
      cancel_session,
      connections,
      init,
      refresh_connection_list,
      remove_connection,
      sessions,
      is_loading_data,
    } = UseCurrentSource(
      // @ts-ignore
      props.modalData.id
    );
    const source = computed(
      () =>
        state.all_sources.value.find(
          // @ts-ignore
          (s) => s.id === props.modalData.id
        )! as SourceBrief
    );

    const sessions_connection_filters: Ref<null | SessionConnectionFilters> = ref(
      null
    );
    const tabs_seed = ["Connections", "Scan Sessions"].map((n) => ({
      id: n,
      name: n,
    }));
    const [tabs, current_tab, _change_tab] = UseTabs(tabs_seed, tabs_seed[0]);
    const change_tab = (tab: { id: string; name: string }) => {
      _change_tab(tab);
      sessions_connection_filters.value = null;
    };

    const show_sessions = (sessions_filets: SessionConnectionFilters) => {
      change_tab(tabs_seed[1]);
      sessions_connection_filters.value = sessions_filets;
    };
    /* 

*/
    const is_loading_connection_desc = ref(false);
    const add_new_connection = () => {
      if (source.value.managedExternally && source.value.id == "onprem_fs") {
        UseModal().show(WalkthroughModalVue, {
          id: "onprem_fs.connection",
          height: "50rem",
        });
      } else {
        add_connection((_is_loading_connection_desc) => {
          if (!_is_loading_connection_desc) {
            // delay so that the modal will open and the spinner will be removed
            // without the ugly flickering
            setTimeout(() => {
              is_loading_connection_desc.value = false;
            }, 400);
          } else {
            is_loading_connection_desc.value = true;
          }
        });
      }
    };

    const subs = {
      during_consent: emptyFn(),
      new_connection_added: emptyFn(),
    };

    onMounted(async () => {
      sessions_connection_filters.value = null;
      subs.new_connection_added = EventBus.listen(
        "refresh_connection_list",
        refresh_connection_list
      );
      if (state.is_during_concent) {
        subs.during_consent = watch(
          state.is_during_concent,
          async (is_still) => {
            if (!is_still) {
              await init();
              subs.during_consent();
            }
          }
        );
      } else {
        await init();
      }
      // @ts-ignore
      if (props.modalData.action) {
        // @ts-ignore
        handle_modal_opening_action(props.modalData.action);
      }
    });

    const handle_modal_opening_action = (action: string) => {
      switch (action) {
        case "start_scan_session":
        default:
          const unwatch = watch(
            is_loading_data,
            async (is_it) => {
              if (!is_it) {
                // @ts-ignore
                const connection_id = props.modalData.connection_id || "";
                const is_session_added = await add_session(connection_id);
                unwatch();
                if (is_session_added) {
                  emit("submit", "added_session");
                }
              }
            },
            { lazy: false }
          );
          break;
      }
    };

    const start_session_from_connection = (connection: any) => {
      add_session(connection.id);
    };

    onBeforeUnmount(() => Object.values(subs).forEach((unsub) => unsub()));

    return {
      is_during_consent: state.is_during_concent,
      config,
      is_loading_data,
      // tabs
      tabs,
      current_tab,
      change_tab,
      // connections
      connections,
      remove_connection,
      add_new_connection,
      is_loading_connection_desc,
      // sessions
      sessions,
      cancel_session,
      add_session,
      sessions_connection_filters,
      show_sessions,
      source,
      start_session_from_connection,
    };
  },
});
